<template>
    <div
        tabindex="0"
        class="gap-y-sm p-sm -mx-sm grid cursor-pointer grid-cols-4 rounded-md transition-all hover:bg-(--surface-highlight) focus:bg-(--surface-highlight)"
        :class="{
            'bg-(--surface-highlight)': selected === true,
            'border border-(--border-subtle)': selected === false && small,
            'mx-0': noMargin,
        }"
        @keydown.enter="$emit('route', notification.id)"
    >
        <div class="gap-sm col-span-4 flex w-full flex-col">
            <h2 class="gap-xs relative flex w-fit items-center" :class="{ 'text-md': small }">
                <i v-if="creator && notification.creator.ID === creatorId" class="i-edit tooltip relative" />
                {{ notification.title }}
                <span
                    v-if="(notification as Notification).acknowledged === 0"
                    class="size-[6px] rounded-full bg-(--icon-primary)"
                />
            </h2>
            <div class="gap-sm flex items-center justify-between" :class="{ 'flex-col': small }">
                <div class="gap-lg flex" :class="{ 'gap-xs w-full flex-col': small }">
                    <p class="text-sm">
                        <span class="text-(--text-muted)">Start date: </span>{{ formatDateTime(notification.startDate) }}
                    </p>
                    <p v-if="notification.endDate && notification.endDate <= new Date()" class="text-sm">
                        <span class="text-(--text-muted)">End date: </span>{{ formatDateTime(notification.endDate) }}
                    </p>
                </div>

                <div
                    class="gap-xs col-start-4 row-span-2 row-start-1 flex h-fit place-self-center"
                    :class="{ 'w-full place-self-start': small }"
                >
                    <TagComponent :value="notification.type" variant="gray" />
                    <TagComponent
                        v-if="(notification.severity as unknown) !== 0"
                        :value="NOTIFICATION_SEVERITY[notification.severity].toLowerCase()"
                        :variant="(NOTIFICATION_SEVERITY[notification.severity].toLowerCase() as any)"
                        class-name="capitalize"
                    />
                </div>
            </div>
            <p>
                {{ notification.summary }}
            </p>
        </div>

        <div v-if="creator" class="gap-xs col-span-4 flex items-center">
            <AvatarArea v-if="creator" :first-name="creator.FIRST_NAME ?? creator.USERNAME ?? 'Undefined'" />
            <div class="flex flex-col overflow-hidden">
                <p class="overflow-hidden text-ellipsis">
                    {{
                        notification.creator.FIRST_NAME
                            ? notification.creator.FIRST_NAME + ' ' + notification.creator.LAST_NAME
                            : notification.creator.USERNAME
                    }}
                </p>
                <p class="overflow-hidden text-sm text-ellipsis">
                    {{ notification.creator.EMAIL }}
                </p>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { type Notification, NOTIFICATION_SEVERITY, type User } from '@/stores/store-interfaces';
import { formatDateTime } from '@/stores/helpers';
import type { PropType } from 'vue';
import AvatarArea from '../avatar-area.vue';
import TagComponent from '@/components/ui/tag/TagComponent.vue';

defineEmits<{ route: [notificationId: string] }>();

defineProps({
    notification: {
        type: Object as PropType<Notification>,
        required: true,
    },
    creator: {
        type: Object as PropType<User>,
        required: false,
    },
    selected: {
        type: Boolean,
        required: false,
    },
    creatorId: {
        type: String,
        required: false,
    },
    noMargin: {
        type: Boolean,
        required: false,
        default: false,
    },
    small: {
        type: Boolean,
        required: false,
        default: false,
    },
});
</script>
